



import {
  Component, Vue, Provide, Watch,
} from 'vue-property-decorator';

export default class extends Vue {
  private created() {
  }
}
